
import { MailOutlined } from '@mui/icons-material';
import { IconButton, Badge, useTheme} from '@mui/material';
import { keyframes } from '@mui/material/styles';
import { MouseEventHandler, useEffect, useState } from 'react';



export type NotificationButtonProps = {
    onClick: MouseEventHandler<HTMLButtonElement>;
    count: number
};


const glow = keyframes` 
from {
    box-shadow: none;
    background-color: transparent;
}
to {
    box-shadow: 0 0 20px 8px rgba(255, 255, 255, 0.4);
    background-color: rgba(255, 255, 255, 0.4);
}
`;

const NOTIFICATION_PULSE_TIMEOUT: number = 30000;

export default function NotificationButton({ count, onClick }: NotificationButtonProps) {

    const [badgeCount, setBadgeCount] = useState(0);
    const [pulse, setPulse] = useState(false);
    const theme = useTheme();

    const onButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setPulse(false);

        if (badgeCount > 0) {
            onClick(event);
        }
    };

    useEffect(() => {

        let timerID: number | undefined;


        const clearTimer = () => {
            if (timerID) {
                window.clearTimeout(timerID);
            }
        }

        if (badgeCount !== count) {
            setBadgeCount(count);

            if (count && count > badgeCount) {
                setPulse(true);

                timerID = window.setTimeout(() => {
                    setPulse(false);
                    clearTimer();
                }, NOTIFICATION_PULSE_TIMEOUT);
            }
        }
    }, [
        count,
        badgeCount,
        setBadgeCount
    ]);
    
    return (
        <IconButton color="inherit"
            size='small'
            aria-label="notifications"
            sx={{
                marginLeft: theme.spacing(1),
                marginRight: theme.spacing(1),
                paddingTop: 1,
                animation: pulse ? `${glow} 1.5s ease-in-out infinite alternate` : undefined
            }}
            onClick={onButtonClick}
        >
            <Badge color='info' badgeContent={badgeCount ? badgeCount : undefined} >
                <MailOutlined sx={{backgroundColor: 'transparent'}} />
            </Badge>                                            
        </IconButton>

    );
}



